import { addYears, startOfYear } from 'date-fns';
import { useMemo } from 'react';
import { z } from 'zod';
import { capacityUsageGranularityValues } from 'src/apis/hydrogen-fcfs/mappings';
import { useNow } from 'src/hooks/use-now';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

const minimumValidFrom = new Date('2030-01-01T00:00:00.000+01:00');

export const getHydrogenCapacityPageParamsSchema = (now: number) => {
  const defaultValidFrom = new Date(
    Math.max(
      minimumValidFrom.getTime(),
      addYears(startOfYear(now), 1).getTime()
    )
  );
  const defaultValidTo = addYears(defaultValidFrom, 10);
  return z.object({
    validFrom: z.string().default(defaultValidFrom.toISOString()),
    validTo: z.string().default(defaultValidTo.toISOString()),
    capacityUsageGranularity: z
      .enum(capacityUsageGranularityValues)
      .default('YEARS'),
  });
};

export function useHydrogenCapacityPageParams() {
  const now = useNow();
  const schema = useMemo(() => getHydrogenCapacityPageParamsSchema(now), [now]);
  return usePageParamsFromSchema(schema, {
    groupPrefix: 'capacity',
    filters: {
      validFrom: { label: 'Validity' },
      validTo: { label: 'Validity' },
      capacityUsageGranularity: { label: 'Capacity Usage Granularity' },
    },
  });
}

export type HydrogenCapacityPageParams = ReturnType<
  typeof useHydrogenCapacityPageParams
>;
